import * as React from 'react';
import Modal from '@sdk/components/ui/modal/Modal';
import { ButtonType } from '@sdk/components/ui/buttons/ButtonType';
import Button from '@sdk/components/ui/buttons/Button';

import {
  Banner,
  ButtonWrapper,
  Description,
  Info,
  Title,
  Wrapper,
  Flag,
} from '@web/components/FeatureAnnouncementModal/featureAnnouncementModal.styles';

type Props = {
  image: React.ReactNode;
  isVisible: boolean;
  dismiss: () => void;
  title: string;
  description: string;
  buttonText: string;
  onButtonClick: () => void;
  bannerBgColor?: string;
  isBeta?: boolean;
};

const DEFAULT_CONFIG = {
  noDismiss: true,
};

const FeatureAnnouncementModal = ({
  image,
  isVisible,
  dismiss,
  title,
  description,
  buttonText,
  onButtonClick,
  bannerBgColor,
  isBeta,
}: Props) => (
  <Modal
    fixed
    config={DEFAULT_CONFIG}
    isVisible={isVisible}
    onDismiss={dismiss}
    closePositionTop={20}>
    <Wrapper>
      <Banner aria-hidden="true" backgroundColor={bannerBgColor}>
        {image}
      </Banner>

      <Info>
        <Title>
          {isBeta && <Flag>Beta</Flag>}
          {title}
        </Title>
        <Description>{description}</Description>
      </Info>

      <ButtonWrapper>
        <Button buttonType={ButtonType.primary} onClick={onButtonClick}>
          {buttonText}
        </Button>
      </ButtonWrapper>
    </Wrapper>
  </Modal>
);
export default FeatureAnnouncementModal;
